
import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateWager = (params) => {
    return axios.post(`${backendHost}/api/admin/wager`, params);
};

export {
    postUpdateWager
}